// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1VUhk","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3CvVd"};